import { Card, CardContent } from "@/components/ui/card";
import { SectionHeading } from "@/components/SectionHeading";

export default function ProcessPage({ content }) {
  const isHindi = content.locale === "hi";
  const processHighlights = Array.isArray(content?.processPage?.highlights) ? content.processPage.highlights : [];
  const processSteps = Array.isArray(content?.processSteps) ? content.processSteps : [];

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <SectionHeading eyebrow={isHindi ? "प्रक्रिया" : "Process"} title={content.processPage.title} description={content.processPage.description} />
      <div className="mt-8 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {processHighlights.map((item, index) => (
          <div key={item} className="rounded-[24px] border border-primary/10 bg-primary/5 px-5 py-5 text-sm font-semibold text-primary" data-testid={`process-page-highlight-${index + 1}`}>
            {item}
          </div>
        ))}
      </div>
      <div className="mt-10 grid gap-6 lg:grid-cols-5">
        {processSteps.map((step, index) => (
          <Card key={step.title} className="rounded-[28px] border-stone-200 bg-white shadow-sm">
            <CardContent className="space-y-4 p-6">
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-base font-bold text-primary" data-testid={`process-page-step-number-${index + 1}`}>
                {index + 1}
              </div>
              <h2 className="font-heading text-2xl font-semibold text-stone-900" data-testid={`process-page-step-title-${index + 1}`}>
                {step.title}
              </h2>
              <p className="text-sm leading-7 text-stone-600" data-testid={`process-page-step-text-${index + 1}`}>
                {step.text}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}